// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"695c3344","350":"4044110a","662":"4d8503c5"}[chunkId] + ".chunk.css";
};